var hooxSliderCentered = document.querySelectorAll('.hoox-swiper-center');

if (hooxSliderCentered) {
    hooxSliderCentered = Array.from(hooxSliderCentered);
    hooxSliderCentered.forEach(element => {
        var slides = element.querySelectorAll('.swiper-slide');
        
        var swiperOptions = {
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 10,
            pagination: {
                el: '.hoox-swiper-center__pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.slider-centered-next',
                prevEl: '.slider-centered-prev',
            },
        };

        if (window.innerWidth < 768 && slides.length > 1) { // Initialize on mobile with more than 1 slide
            new Swiper(element, swiperOptions);
        } else if (window.innerWidth >= 768 && slides.length > 3) { // Initialize on desktop with more than 3 slides
            swiperOptions.breakpoints = {
                767: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                }
            };
            new Swiper(element, swiperOptions);
        } else { // Hide navigation arrows if Swiper is not initialized
            var navigation = element.querySelectorAll('.slider-centered-next, .slider-centered-prev');
            navigation.forEach(navItem => {
                navItem.style.height = '0';
            });
        }
    });
}
